import { http } from '../../core/services/http';
import translate from '../../core/services/translate';
import { downloadExcelFilebyPost } from '../../utils/services/downloadExcelFile';
import { InvoiceSearchParams } from '../interfaces/InvoiceSearchParams';
import { transformInvoices } from './transformInvoices';
import { LIMIT_PER_PAGE, PAGE } from 'src/core/constants';

export const loadInvoices = (findInvoicesObj: InvoiceSearchParams, page: number = PAGE, limit: number = LIMIT_PER_PAGE) =>
  http.post(`gus/vendor/invoice/search`, {
    ...findInvoicesObj,
    pageNumber: page,
    pageSize: limit,
  }).then(response => {
    return { invoices: transformInvoices(response.data.invoices), total: response.data.total };
  });

export const exportInvoices = (findInvoicesObj: InvoiceSearchParams) => {
  return downloadExcelFilebyPost(
    `gus/vendor/invoice/search/export`,
    `${translate('invoice.invoices')}`,
    findInvoicesObj,
  );
};
